import axios from 'axios';
import * as config from "../api/data";

const headers:any = {
    'client_secret': process.env.REACT_APP_CI_FOCUS21_FE_SECRET,
}

export async function getSlots(uid:string) {
    // let url:string;
    // if(window.location.origin==='https://') {
    //     url = config.getSlotsALBURL();
    // } else {
    //     url = config.getSlotsURL();
    // }
    headers.uid = uid;
    return axios.get(config.getSlotsURL(),{headers:headers})
}

export async function bookSlot(uid:string, slotID:string) {
    // let url:string;
    // if(window.location.origin==='https://') {
    //     url = config.bookSlotALBURL();
    // } else {
    //     url = config.bookSlotURL();
    // }
    headers.uid = uid;
    let data = {timeslot:slotID};
    return axios.post(config.bookSlotURL(), data ,{headers:headers})
}

export async function cancelticket() {
    return
}

export async function reOpenTicket() {
    return
}

export async function refreshMapCordinates(uid:String) {
    headers.uid = uid;
    return axios.get(config.refreshCordinates(), {headers:headers}).then(resp=>resp.data);
}